<template>
  <div>
  </div>
</template>

<script>
// import { routes } from '@/router/index';

export default {
  name: 'Homepage',
  // data: () => ({
  //   routes,
  // }),
};
</script>

<style></style>
